import React from 'react'
import { Button, Icon } from '@blueprintjs/core';
import { Suggest } from '@blueprintjs/select';
import { observable, action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Api } from 'services/Api';
import axios from 'axios';
import debounce from 'services/debounce';
import { projectRenderer, ProjectDetails, ProjectListRenderer } from 'components/ProjectSuggest';

// The job form's list is already one client's projects.
const renderProject = projectRenderer({ showClient: false });

@observer
class ProjectAutocomplete extends React.Component {

  @observable loading = true;
  @observable failed = false;
  @observable results = [];
  @observable selectedProject = null;
  @observable scope = null;

  componentDidMount() {
    let {
      selectedProjectId
    } = this.props;
    if (selectedProjectId) {
      let promise = Api.get(`/projects/${selectedProjectId}`)
      promise.then(response => {
        this.selectedProject = response.data.data;
      })
    }
  }

  @action
  onQueryChange(query) {
    let { scope } = this.props;
    this.failed = false;
    this.loading = true;
    let search = { term: query, per_page: 50, page: 1, order: { name: 'asc' } };
    if(scope){
      search['where'] = scope;
    }
    let promise = Api.post('/projects/search', { search: search })
    promise
      .then(this.onProjectsLoad.bind(this))
      .catch(this.onProjectsLoadFail.bind(this))

    return promise;
  }

  @action
  onProjectsLoadFail(error) {
    if (axios.isCancel(error)) {
      this.loading = true;
    } else {
      this.loading = false;
      this.failed = true;
    }
  }

  @action
  onProjectsLoad(response) {
    this.loading = false;
    this.failed = false;
    this.results = response.data.data;
  }

  @action
  onProjectSelect(project) {
    this.selectedProject = project;
    this.props.onProjectSelect(project);
  }

  @action
  clearSelectedProject() {
    this.selectedProject = null;
    this.props.onProjectSelect(null);
  }

  // The chosen project as one field: name, number and status, a link to the
  // project and a button to pick another.
  renderPicked(project) {
    const a = project.attributes || {};
    const name = a.name || 'Untitled project';
    return (
      <div className="client-picked project-picked">
        <span className="client-suggest-avatar project-suggest-icon" aria-hidden="true"><Icon icon="projects" iconSize={14} /></span>
        <span className="client-picked__text">
          <span className="client-picked__name" title={name}>{name}</span>
          <span className="client-picked__meta"><ProjectDetails project={project} showClient={false} compact={true} /></span>
        </span>
        {project.id && (
          <a
            className="client-picked__action"
            href={`/dashboard/projects/${project.id}/show`}
            target="_blank"
            rel="noopener noreferrer"
            title="Open the project in a new tab"
            aria-label={`Open ${name} in a new tab`}
          >
            <Icon icon="share" iconSize={14} />
          </a>
        )}
        <button
          type="button"
          className="client-picked__action"
          onClick={() => this.clearSelectedProject()}
          title="Choose a different project"
          aria-label="Choose a different project"
        >
          <Icon icon="cross" iconSize={14} />
        </button>
      </div>
    );
  }

  render() {
    if (this.selectedProject && this.selectedProject.attributes) {
      return this.renderPicked(this.selectedProject);
    }
    let {
      failed,
      results,
      onQueryChange,
      loading,
      onProjectSelect,
      selectedProject,
      clearSelectedProject,
      props: {
        inputProps
      }
    } = this;
    return(
      <div className="client-name-field">
        {
          selectedProject ? <Button 
              text={
                this.selectedProject && this.selectedProject.attributes
                  ? `${this.selectedProject.attributes.number || ''} ${this.selectedProject.attributes.name || ''}`.trim()
                  : ''
              }
              rightIcon='cross'
              onClick={clearSelectedProject.bind(this)}
            /> : <Suggest
              inputProps={{
                icon: 'cross',
                placeholder: 'Search project...',
                onClick: onQueryChange.bind(this, ""),
                ...inputProps
              }}
              closeOnSelect={true}
              resetOnQuery={true}
              resetOnSelect={true}
              popoverProps={{ minimal: true }}
              onQueryChange={debounce(onQueryChange.bind(this)).bind(this)}
              items={toJS(results)}
              itemRenderer={renderProject}
              itemListRenderer={(props) => <ProjectListRenderer {...props} loading={loading} failed={failed} />}
              inputValueRenderer={(project) => project.attributes.name }
              onItemSelect={onProjectSelect.bind(this)}
            />
        }
      </div>
    )
  }
}

ProjectAutocomplete.propTypes = {
  inputProps: PropTypes.object,
  onProjectSelect: PropTypes.func.isRequired
}

export default ProjectAutocomplete;